import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SelfDiagnosisFacade } from '../../../../store/self-diagnostic/self-diagnosis/facade';
import { SelfDiagnosisModel } from '../../../../store/self-diagnostic/self-diagnosis/model';
import { List } from '../../../../core/infrastructure/linq';
import { ServiceCatalogFacade } from '../../../../store/self-diagnostic/service-catalog/facade';
import { ServiceModel } from '../../../../store/self-diagnostic/service-catalog/model';
import { filter } from 'rxjs/operators';
import { UserFacade } from '../../../../store/user/facade';
import { AppConstants } from '../../../../core/constants/app-constants';

declare var gtag;

@Component({
  selector: 'app-self-diagnostic-self-diagnostic-step',
  templateUrl: './self-diagnostic-step.component.html',
  styleUrls: ['./self-diagnostic-step.component.scss'],
  standalone: false,
})
export class SelfDiagnosticStepComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  translate = inject(TranslateService);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);
  private selfDiagnosisFacade = inject(SelfDiagnosisFacade);
  private titleService = inject(Title);
  private userFacade = inject(UserFacade);

  public isUkLanguage: boolean;

  public step: number = 0;
  public stepsCount: number = 0;

  public service: ServiceModel;
  public selfDiagnosis: SelfDiagnosisModel;

  private userFacadeSub: Subscription;
  private serviceCatalogFacadeSub: Subscription;
  private selfDiagnosisFacadeSub: Subscription;

  public ngOnDestroy() {
    this.userFacadeSub?.unsubscribe();
    this.serviceCatalogFacadeSub?.unsubscribe();
    this.selfDiagnosisFacadeSub?.unsubscribe();
  }

  public ngOnInit(): void {
    this.userFacadeSub = this.userFacade.selected().subscribe(user => {
      if (user) {
        this.isUkLanguage = !user.language || user.language == AppConstants.LANGUAGE_UK;
      }
    });

    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });

    this.selfDiagnosisFacadeSub = this.selfDiagnosisFacade.selected$.subscribe(async entity => {
      if (entity) {
        this.selfDiagnosis = { ...entity };
        this.selfDiagnosis.selfDiagnosisSteps = new List(entity.selfDiagnosisSteps)
          .Select(s => {
            return { ...s };
          })
          .ToArray();

        this.stepsCount = this.selfDiagnosis.selfDiagnosisSteps.length;

        this.serviceCatalogFacadeSub = this.serviceCatalogFacade.filtered$
          .pipe(filter(s => Array.isArray(s) && !!s.length))
          .subscribe(s$ => {
            this.service = new List(s$).Single(s => s.id == this.selfDiagnosis.serviceId);
          });
      }
    });

    this.route.params.subscribe(async params => {
      let selfDiagnosisId = +params['selfDiagnosisId'];

      if (selfDiagnosisId) {
        this.selfDiagnosisFacade.getById(selfDiagnosisId);
      }
    });
  }

  public prevStep() {
    this.step--;
  }

  public nextStep() {
    this.step++;
  }

  public goRatePage() {
    this.router.navigate(['/self-diagnostic/rate'], {
      queryParams: { stepId: this.selfDiagnosis.selfDiagnosisSteps[this.step].id },
    });

    gtag('event', 'self_diagnostic_steps_helped');
  }

  public createOrder() {
    this.router.navigate(['/orders/order'], {
      queryParams: {
        categoryId: this.service.category.code,
        categoryName: this.isUkLanguage ? this.service.category.nameUa : this.service.category.nameRu,
        serviceId: this.service.code,
        serviceName: this.isUkLanguage ? this.service.nameUa : this.service.nameRu,
        serviceTypeId: null,
      },
    });

    gtag('event', 'self_diagnostic_steps_did_not_help');
  }
}
